import React, { useCallback, useEffect, useRef } from "react";
import Flatpickr from "react-flatpickr";

import { useCalendarOptions, useResponsiveMonths, replaceYearInputWithSelect } from "./useCalendar";

/**
 * インライン表示のカレンダーコンポーネント
 */
const InlineCalendar = ({
  mode = "multiple",
  value,
  onChange,
  minDate,
  maxDate,
  dateFormat,
  allowInput = false,
  yearRange,
  className,
  options: additionalOptions = {},
  ...props
}) => {
  // レスポンシブな月表示数を取得。単一日選択（single）は範囲選択ではないため
  // 常に1ヶ月表示にする（2ヶ月並べる必要があるのは range のみ）。
  const responsiveMonths = useResponsiveMonths();
  const showMonths = mode === "single" ? 1 : responsiveMonths;
  
  // flatpickrインスタンスへの参照
  const flatpickrRef = useRef(null);

  // カレンダーオプションの設定
  const options = useCalendarOptions({
    mode,
    inline: true,
    minDate,
    maxDate,
    allowInput,
    dateFormat,
    yearRange,
    additionalOptions: {
      ...additionalOptions,
      showMonths
    }
  });

  // showMonthsが変更されたときにflatpickrを更新
  useEffect(() => {
    if (flatpickrRef.current && flatpickrRef.current.flatpickr) {
      const fp = flatpickrRef.current.flatpickr;
      fp.set('showMonths', showMonths);
      
      setTimeout(() => {
        const calendar = fp.calendarContainer;
        if (calendar) {
          if (showMonths > 1) {
            calendar.classList.add('multiMonth');
          } else {
            calendar.classList.remove('multiMonth');
          }
        }
        const currentYear = new Date().getFullYear();
        const [minY, maxY] = yearRange || [currentYear - 100, currentYear + 10];
        replaceYearInputWithSelect(fp, minY, maxY);
      }, 0);
    }
  }, [showMonths, yearRange]);

  // 日付変更時のハンドラ
  const handleChange = useCallback((dates) => {
    if (onChange) {
      onChange(dates);
    }
  }, [onChange]);

  return (
    <Flatpickr
      ref={flatpickrRef}
      options={options}
      value={value}
      onChange={handleChange}
      className={className}
      style={{ display: "none" }}
      {...props}
    />
  );
};

export default React.memo(InlineCalendar, (prevProps, nextProps) => {
  return (
    prevProps.value === nextProps.value &&
    prevProps.minDate === nextProps.minDate &&
    prevProps.maxDate === nextProps.maxDate &&
    prevProps.mode === nextProps.mode
  );
}); 